// extracted by mini-css-extract-plugin
export var backupIcon = "_sg-1";
export var image = "_sg-0";